import React from 'react'
import PushSettingsCard from '@/modules/pwa/components/PushSettingsCard'
import AnalysisPostPushSettingsCard from '@/modules/pwa/components/AnalysisPostPushSettingsCard'
import VisionPostPushSettingsCard from '@/modules/pwa/components/VisionPostPushSettingsCard'
import ChatPostPushSettingsCard from '@/modules/pwa/components/ChatPostPushSettingsCard'
import OpportunityConversationPushSettingsCard from '@/modules/pwa/components/OpportunityConversationPushSettingsCard'
import PushScheduleSettingsCard from '@/modules/pwa/components/PushScheduleSettingsCard'

export default function UserNotificationsSection() {
  return (
    <div className="space-y-4">
      <PushSettingsCard />
      <AnalysisPostPushSettingsCard />
      <VisionPostPushSettingsCard />
      <ChatPostPushSettingsCard />
      <OpportunityConversationPushSettingsCard />
      <PushScheduleSettingsCard />
    </div>
  )
}
